import { authPost } from "@api";
import { withToaster } from "@utils";

export const postHasAutofix = (deploymentId: string, autofix: boolean) =>
  withToaster(
    () =>
      authPost<{}, { has_autofix: boolean }>(
        `/api/agent/deployments/${deploymentId}/has_autofix`,
        { has_autofix: autofix }
      ),
    (err) => `Could not set autofix: ${err.body?.error}`
  )();
